<template>
  <el-dialog :title="popType==3?'团队调整':'客户调整'" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
    <div class="flexs">
      <Title :isLine="false">{{popType==3?'下级团队':'客户'}}</Title>
      <!-- <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-if="popType==3"
        style="margin: 0 20px 20px;">添加团队</el-button> -->
    </div>
    <el-table v-loading="listLoading" :data="list" height="300px">
      <el-table-column :label="popType==3?'业务员信息':'客户信息'" prop="name" align="center" fixed>
        <template slot-scope="{row}">
          <div @click="handleShow(row,2)">
            <!-- <el-link type="primary">{{popType==3?row.customer.name:row.name}}</el-link><br /> -->
            <el-link type="primary">{{row.customer.name}}</el-link><br />
            <el-link type="primary">{{row.customer.pho}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="身份" prop="" align="center">
        <template slot-scope="{row}">
          {{row.customerLevel.name}}
        </template>
      </el-table-column>
      <el-table-column label="所属区域" prop="orderNo" align="center" width="200" v-if="popType==7">
        <template slot-scope="{row}" v-if="row.addr && row.addr.length">
          {{row.addr[0].regionName}}{{row.addr[1].regionName}}{{row.addr[2].regionName}}
        </template>
      </el-table-column>
      <el-table-column label="加入时间" prop="createdTime" sortable="custom" align="center" width="200">
        <template slot-scope="{row}">
          {{dayjs(row.customer.createdTime).format("YYYY-MM-DD HH:mm:ss")}}
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    <Title :isLine="false" class="mt10">移除{{popType==3?'团队':'客户'}}</Title>
    <div v-for="(item,index) in form.childDetail" :key="index" class="full-box">
      <el-select v-model="item.beCustomerid" :placeholder="`请选择需要移除的${popType==3?'团队':'客户'}`" multiple clearable collapse-tags size="small" @change="customerChange" filterable>
        <el-option v-for="(it,index) in options.customerOptions" :key="it.customer.id" collapse-tags :label="it.customer.name + '(' + it.customerLevel.name +')' + it.customer.pho" :value="it.customer.id"></el-option>
      </el-select>
      <el-select v-model="item.toCustomerid" placeholder="请选择业务员" clearable size="small" filterable :filter-method="customerFilter" @blur="getBusinessList(maxLevel)">
        <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.name} (${it.pho})`" :value="it.id"></el-option>
      </el-select>
      <!-- <el-select v-model="item.technicianId" placeholder="请选择业务员" clearable size="small" v-else>
        <el-option v-for="(it,index) in identityOptions" :key="index" :label="it.name" :value="it.id"></el-option>
      </el-select> -->
      <div class="full-icon">
        <i class="el-icon-plus" @click="handleAddCustomer"></i>
        <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false,tabType=1">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import technicianInfoApi from '@/api/technical/technicianInfo'
import clientListApi from '@/api/client/clientList'

function initFormBean() {
  const formBean = {
    radio1: null,
    radio2: null,
    radio3: null,
    areaList: [],
    childDetail: [

    ]
  }
  return formBean
}
export default {
  props: ['popType', 'identityOptions'],
  data() {
    return {
      formVisible: false,
      form: initFormBean(),
      listLoading: true,
      isLoading: false,
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      total: 0,
      list: [],
      options: {
        identityOptions: [],
        customerOptions: []
      },
      obj: {
        beCustomerid: [],
      },
      maxLevel: null
    }
  },
  mounted() {
    // console.log('==============');
    // this.doQueryList({})
  },
  methods: {
    customerFilter(e) {
      this.getBusinessList(this.maxLevel, e)
    },
    async customerChange(e) {
      if (this.popType != 3) return
      let arr = []
      if (e.length) {
        arr = e.map(item => {
          return this.options.customerOptions.find(i => i.customer.id == item).customer.clevel
        })
        // this.options.identityOptions=this.options.identityOptions.map(i)
        // this.maxLevel=Math.min(...arr)
        // await this.getBusinessList(this.maxLevel)
        // await this.getBusinessList()
      } else {
        // this.options.identityOptions=[]
        // await this.getBusinessList()
      }
      // console.log('e: ',e,this.identityOptions,this.options.customerOptions,arr);
    },
    // 获取业务员
    getBusinessList(maxLevel, val) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100
      }
      if (maxLevel) {
        obj.maxLevel = maxLevel
      }
      obj.name = val
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.options.identityOptions = data.list
     
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
      this.options.identityOptions = []
      this.options.customerOptions = []
    },
    handleUpdate(data) {
      this.resetForm()
      this.form = {
        ...this.form,
        ...data.row
      }
      console.log('this.form: --------', this.form, this.popType, data);
      this.formVisible = true
      this.$nextTick(() => {
        // this.$refs['dataForm'].clearValidate()
        this.doQueryList({})
        this.getOptionList()
        // if(this.popType!=3){
        this.getBusinessList()
        // }
        // this.handleTechnical()
        // if (this.popType == 3) {
        // this.$set(this.obj, 'beCustomerid', '')
        // this.getTeam()
        // } else {
        this.$set(this.obj, 'toCustomerid', '')
        // this.getClient()
        // }
        console.log('this.obj: ', this.obj);
        this.form.childDetail.push({
          ...JSON.parse(JSON.stringify(this.obj))
        })
      })
    },
    //指定分配 团队、客户
    getOptionList() {
      let query = {
        parentId: this.form.customer.id,
        pageNo: 1,
        pageSize: 1000
      }
      query.customerType = this.popType == 3 ? 2 : 3
      clientListApi.fetchList2(query)
        .then(data => {
          this.options.customerOptions = data.data.list
          console.log('-----option: ', this.options.customerOptions);
        })
    },
    formatCascaderData(data) {
      return data.reduce((data, item) => (data.push(...item.beCustomerid.map(id => ({
        ...item,
        beCustomerid: id,
      }))), data), [])
    },
    // 确定
    async doCreate() {

      let obj = {}
      // console.log(' this.form.childDetail: ', this.form.childDetail);
      let arr = this.formatCascaderData(this.form.childDetail)
      obj.customerid = this.form.customer.id
      obj.isDeparted = 0
      if (this.popType == 3) {
        obj.connectTeam = arr
        obj.dataCompareLogType2 = 23
      } else {
        obj.connectCustomer = arr
        obj.dataCompareLogType2 = 24
      }
      console.log('arr: ', obj);
      // return
      this.isLoading = true
      await clientListApi.resignQuit([obj]).then(res => {
        this.$message.success('提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度')
        this.formVisible = false;
        this.$emit('created')
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.state = 1
      this.query.parentId = this.form.customer.id
      this.query.customerType = this.popType == 3 ? 2 : 3
      // this.clacPrams()
      this.listLoading = true
      return clientListApi.fetchList2(this.query)
        .then(data => {
          this.list = data.data.list
          console.log('this.list: ', this.list);
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })

    },
    handleDeleteCustomer(index) {
      if (this.form.childDetail.length <= 1) return
      this.form.childDetail.splice(index, 1)
    },
    handleAddCustomer() {
      this.form.childDetail.push(JSON.parse(JSON.stringify(this.obj)))
      console.log('this.form.childDetail: ', this.form.childDetail);
    },
  }
}
</script>

<style  lang="scss" scoped>
::v-deep .el-dialog {
  margin-top: 5vh;
}
</style>
